<script setup lang="ts">
/** Catalogue thumbnail from the row's signed `cover_url`; `null` (no cover, or unsignable path) is
 *  a placeholder. The link expires in 6h — a stale tab shows a broken image until reload, by design. */
import type { AssignmentTemplateListRow } from '../../../model/assignments/interfaces'

import { faImageSlash } from '@fortawesome/pro-regular-svg-icons'

import { AppIcon } from '@shared/ui/icons'

defineOptions({
  name: 'AssignmentTemplateCover',
})

defineProps<{
  template: AssignmentTemplateListRow
}>()
</script>

<template>
  <div class="assignment-template-cover">
    <img
      v-if="template.cover_url"
      class="assignment-template-cover__image"
      :src="template.cover_url"
      :alt="`Cover of ${template.title}`"
      loading="lazy"
    >
    <AppIcon
      v-else
      :icon="faImageSlash"
      size="small"
      color="slate-400"
    />
  </div>
</template>

<style scoped lang="scss" src="./AssignmentTemplateCover.scss" />
